import React, { useEffect } from "react";
import logo from "./logo.png";
import logoSupport from "./logo_old.png";
import "./style.css";
import { useHistory } from "react-router-dom";
import { CircleHelp, Power } from "lucide-react";
import { version } from "../../../../package.json";

export default function PageLayout({
  centerLogo = false,
  supportMode = false,
  ...props
}) {
  const history = useHistory();
  const buildNumber = process.env.REACT_APP_BUILD_NUMBER || "dev";

  useEffect(() => {
    if (props.location && props.location.hash === "#connect") {
      // Handle any initial setup if needed
    }
  }, []);

  const handleLogout = () => {
    // Clear session storage
    sessionStorage.clear();
    // Redirect to login
    history.push("/login");
  };

  return (
    <div className="app">
      <div
        className={`flex items-center justify-between h-14 ${
          centerLogo ? "relative" : ""
        }`}
        style={{
          backgroundColor: supportMode ? "#ffffff" : "#3f4b5c",
          boxShadow: supportMode
            ? "0 2px 4px 0 rgba(29,31,41,.15)"
            : "0 4px 8px rgba(0, 0, 0, 0.4)",
        }}
      >
        <div className="flex items-center">
          <div
            className={`flex items-center ${
              centerLogo
                ? "absolute left-1/2 top-1 transform -translate-x-1/2"
                : "pl-5"
            }`}
          >
            <img
              src={supportMode ? logoSupport : logo}
              alt="logo"
              style={{ height: supportMode ? "36px" : "28px" }}
            />
          </div>
        </div>

        {!supportMode && (
          <div className="flex items-center gap-4 pr-5">
            <button
              className="text-white hover:text-slate-300 transition-colors"
              onClick={() => {
                window.open(
                  "https://learning.deltek.com/category/computerease_field",
                  "_blank"
                );
              }}
              aria-label="Help"
            >
              <CircleHelp size={24} />
            </button>
            <button
              className="text-white hover:text-slate-300 transition-colors"
              onClick={handleLogout}
              aria-label="Logout"
            >
              <Power size={24} />
            </button>
          </div>
        )}
      </div>

      <div className="app-body">
        <div
          className={`app-body__content app-body__content--full${
            supportMode ? " app-body__content--support" : ""
          }`}
        >
          <div className="app-body__page">
            {props.children}
            <div
              className="flex items-center justify-center gap-4 py-3 px-5 text-sm"
              style={{
                color: "#cbd5e1",
                marginTop: "6px",
              }}
            >
              <a
                href="https://www.deltek.com/en/deltek-contracts/general-privacy-terms"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:underline"
                style={{ color: "#cbd5e1" }}
              >
                Privacy Policy
              </a>
              <span>|</span>
              <span>&copy; 2026 Deltek, Inc.</span>
              {!supportMode && (
                <>
                  <span>|</span>
                  <span>Version {version}</span>
                  <span>|</span>
                  <span>Build {buildNumber}</span>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
